import useTeamContext from '@maxpreps/shared/contexts/TeamContext';
import Anchor from '@maxpreps/shared/corecomponents/Anchor/Anchor';
import { isFreelanceLeague } from '@maxpreps/shared/functions/utils/leagueUtils';
import Font from '@maxpreps/shared/styles/font';
import StyledText from '@maxpreps/shared/ui/Text/StyledText';
import React from 'react';
import { NIL as EMPTY_GUID } from 'uuid';
import getIsPublishedSportSeason from './../../../utils/getIsPublishedSportSeason';
import WinPercentage from './WinPercentage';

interface IRecordLeagueDataProps {
  leagueStandingPlacement: string | undefined;
  leagueCanonicalUrl: string | undefined;
  leagueWinPercentage: number | string;
}

// Component only rendered for valid leagues
const RecordLeagueData: React.FC<IRecordLeagueDataProps> = ({
  leagueStandingPlacement,
  leagueWinPercentage,
  leagueCanonicalUrl
}) => {
  const teamContext = useTeamContext();

  const { stateData, data, teamSeasonPickerData } = teamContext;
  const { leagueAlias } = stateData;
  const { leagueId, leagueName, sportSeasonId } = data;

  // If we don't have a league grouping - just show win %
  if (leagueId === EMPTY_GUID) {
    return <WinPercentage winningPercentage={leagueWinPercentage as number} />;
  }

  const isFreelance = isFreelanceLeague(leagueName);
  const showLeagueName = !!leagueName && leagueName.length < 21;

  // shorten the league name if needed for display purposes
  const formattedLeagueName = showLeagueName
    ? leagueName
    : isFreelance
    ? 'Freelance'
    : leagueAlias;

  const sharedProps = {
    $marginLeft: '4px',
    className: Font.f12_tall
  };

  const leagueNameComponent =
    leagueCanonicalUrl &&
    getIsPublishedSportSeason(sportSeasonId, teamSeasonPickerData) ? (
      <Anchor {...sharedProps} href={leagueCanonicalUrl}>
        {formattedLeagueName}
      </Anchor>
    ) : (
      <StyledText {...sharedProps}>{formattedLeagueName}</StyledText>
    );

  // always show league name
  // if we aren't a freelance league thena lso show the league placement
  return (
    <StyledText className={Font.f12_bold_tall}>
      {!isFreelance && leagueStandingPlacement && (
        <>
          {leagueStandingPlacement}
          {!showLeagueName && (
            <StyledText $marginLeft="4px" className={Font.f12_tall}>
              in
            </StyledText>
          )}
        </>
      )}
      {leagueNameComponent}
    </StyledText>
  );
};

export default RecordLeagueData;
